<lib-overlayer
  popUpID="overlayer-id-loginRequired"
  [showModal]="showModal"
  [displaySubTitle]="false"
  [options]="options"
  (onClose)="closeModal()"
  [displayFooter]="true"
  [closeButtonHoverTitle]="'bills.common.buttons.close' | translate"
>
  <ng-container Title>
    {{ 'bills.billDetailsPanel.loginRequiredModal.title' | translate }}
  </ng-container>

  <ng-container Content>
    <p>
      {{ 'bills.billDetailsPanel.loginRequiredModal.description' | translate }}
    </p>
  </ng-container>

  <ng-container Footer>
    <div class="text-right">
      <button
        (click)="onClickOnLogin()"
        class="rs-btn"
        data-cy="myBillModalLoginRequired"
      >
        {{
          'bills.billDetailsPanel.loginRequiredModal.buttonTitle' | translate
        }}
      </button>
    </div>
  </ng-container>
</lib-overlayer>
